module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar2-d49cf34477d8138d0d491efd30bab525.svg";